import React from 'react';

import { Button } from 'react-bootstrap';

import api from 'api';
import { formTitle } from 'helpers/forms';
import useCurrentApplication from 'hooks/useCurrentApplication';
import { getProgramTypeFromApplicationType } from 'utils/enums';
import useMountEffect from 'hooks/useMountEffect';
import useRequest from 'hooks/useRequest';

import SectionWrapper from 'components/layout/SectionWrapper';
import { HistoryBackButton } from 'components/elements/BackButton';
import { FlexDivSpaceBetweenCenter } from 'resources/styles/display';

import FinalReportScreen from './FinalReportScreen';

export default function FinalReport() {
  const { appData } = useCurrentApplication();

  const { data, doRequest, isLoading } = useRequest(api.downloadFinalReport);

  const pdf = React.useMemo(() => {
    if (!data) return null;
    return {
      blob: new Blob([data], { type: 'application/pdf' }),
      url: URL.createObjectURL(data),
    };
  }, [data]);

  const title = `${appData.bcqpBurnCenterName} - ${getProgramTypeFromApplicationType(appData.applicationType)} ${formTitle.siteReport}`;

  useMountEffect(() => doRequest(appData.id));

  return (
    <SectionWrapper title={title}>
      <FlexDivSpaceBetweenCenter>
        <HistoryBackButton />
        <Button
          disabled={!pdf?.url && !isLoading}
          download={`Verification Site Report - ${appData.bcqpBurnCenterName}.pdf`}
          href={pdf?.url}
        >
          Download Site Report
        </Button>
      </FlexDivSpaceBetweenCenter>
      <FinalReportScreen pdf={pdf?.blob} />
    </SectionWrapper>
  );
}
